import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { TooltipComponent } from "../../../../common/tooltip/tooltip.component";


@Component({
    selector: 'calendar-availability',
    templateUrl: '../../templates/partials/calendar-availability.html'
})

export class CalendarAvailabilityComponent implements OnInit {
    constructor() { }
    @Input() availability;
    public popUpHtml;
    public previosTooltip = null;
    @ViewChildren("pop") tooltips;

    public setItemClass(hour){
        let returnClass;
        if(hour.availability){
            if(hour.cleaners == 0){
             returnClass = "c-cleaner-availability__item--fool";
            }else if(hour.cleaners > 3){
             returnClass = "c-cleaner-availability__item--low";
            }else{
             returnClass = "c-cleaner-availability__item--medium";
            }
        }else{
            returnClass = "";
        }

        return returnClass;
    }

    public show(element,hour){
        //console.log(element);
        //console.log(this.tooltips);
        if(hour.availability){
            if(this.previosTooltip != null){
                this.previosTooltip.hide();
            }
            element.show();
            this.previosTooltip = element;
        }
    }

    onShownTooltip(event, hour) {
        //console.log(hour);
        //this.popUpHtml = hour.cleaners;
    }
    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/availability/components/dummy/calendar-availability.component.ts